<mat-card style="padding-bottom: 10px;" id="transaction-summary">
    <mat-card-content>
      <app-matspinner *ngIf="isLoading"></app-matspinner>
      
      <mat-card-header>
        <mat-card-title class="title">Transaction Summary</mat-card-title>
      </mat-card-header>
      
      <mat-divider  class="divider"></mat-divider>
      
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true"
        (closed)="panelOpenState = false" [expanded]=true>
          <mat-expansion-panel-header style="height: 30px;">
          </mat-expansion-panel-header>
          <div class="container">
              <div class="row">
                  <div class="col-md-3">
                      <label class="lbl_fld">Message ID</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_val">{{transactionRequestData.MessageID}}</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_fld">Date/Time Rec'd</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_val">{{transactionRequestData.RequestDate}}</label>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-3">
                      <label class="lbl_fld">Relates to Message ID</label>
                  </div>
                  <div class="col-md-3" id="a-header" *ngIf="transactionRequestData.RelatesToRequestId!=''">
                      <a id="a-header-content" class="lbl_val" (click)="redirectToDetails(transactionRequestData.RelatesToRequestId)">{{transactionRequestData.RelatesToMessageID}}</a>
                  </div>
                  <div class="col-md-3" id="a-header" *ngIf="transactionRequestData.RelatesToRequestId==''">
                    <label class="lbl_val">{{transactionRequestData.RelatesToMessageID}}</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_fld">Pharmacy Chain Name</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_val">{{transactionRequestData.PharmacyName}}</label>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-3">
                      <label class="lbl_fld">Message Type</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_val">{{transactionRequestData.MessageType}}</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_fld">Pharmacy NCPDP ID</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_val">{{transactionRequestData.PharmacyNCPDPID}}</label>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-3">
                      <label class="lbl_fld">Species</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_val">{{transactionRequestData.Species}}</label>
                  </div>
                  <div class="col-md-3">
                    <label class="lbl_fld">Pet Transactions Enabled</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_val">{{transactionRequestData.PetEnabled=="True"?"Yes":"No"}}</label>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-3">
                      <label class="lbl_fld">Patient Last Name</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_val">{{transactionRequestData.PatientLastName}}</label>
                  </div>
                  <div class="col-md-3">
                    <label class="lbl_fld">Transaction Status</label>
                  </div>
                  <div class="col-md-3">
                      <label class="lbl_val">{{transactionRequestData.ResponseStatus}}</label>
                  </div>
              </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
    <mat-card-content>
      <br>
      <mat-divider class="divider"></mat-divider>
      <mat-tab-group class="global-tabs" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
        <!-- REQUEST TAB -->
            <!-- <mat-tab label={{requestTabTitle}}> -->
            <mat-tab label= "NewRx">
          <mat-card-content style="height: 480px; overflow-y: auto;">
            <div class="store-search-row">
              <div class="form-group search-group">
                <mat-form-field class="ffs" appearance="outline" style="font-size: 18px;">
                  <input
                    id="filternodeId"
                    matInput
                    minlength="2"
                    (keyup)="applyFilter($event)"
                    placeholder="Search"
                    #input
                    autocomplete="off"
                  >
                </mat-form-field>
              </div>
              <div class="export-button" style="gap: 5%; margin-right: 2%;">
                <button mat-raised-button type="button" class="btn-save" (click)="expandorcollapse('expand')">Expand All</button>
                <button mat-raised-button style="margin-left: 1%;" type="button" class="btn-cancel" (click)="expandorcollapse('collapse')">Collapse All</button>
              </div>
            </div>
    



                      <div _ngcontent-etx-c320="" class="ng-star-inserted" style="margin-left:48px">
                        <table class="response-title-width">
                          <tbody>
                            <tr>
                              <td class="request-key-title-border"><span class="response-title-key">  Message Id</span></td>
                              <td class="request-key-title-border"><span class="response-title-key">  Relates To Message Id</span></td>
                              <td class="request-key-title-border"><span class="response-title-key">  Message Type</span></td>
                              <td class="request-key-title-border"><span class="response-title-key">  Species</span></td>
                              <td class="request-key-title-border"><span class="response-title-key">  Request Date</span></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div style="display: flex;">
                      <button _ngcontent-jcb-c320="" mat-icon-button="" style="padding-top: 6px;" 
                        mattreenodetoggle="" class="mdc-icon-button mat-mdc-icon-button mat-unthemed mat-mdc-button-base" aria-label="toggle Message" (click)="expandRequest()" [disabled]="!isRequestJSONAvail">
                        <span class="mat-mdc-button-persistent-ripple mdc-icon-button__ripple"></span>
                        <mat-icon *ngIf="IsCollapsed" _ngcontent-jcb-c320="" role="img" class="mat-icon notranslate mat-icon-rtl-mirror material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" [hidden]="!isRequestJSONAvail"> chevron_right </mat-icon>
                        <mat-icon *ngIf="!IsCollapsed" _ngcontent-jcb-c320="" role="img" class="mat-icon notranslate mat-icon-rtl-mirror material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" [hidden]="!isRequestJSONAvail"> expand_more </mat-icon>
                        <span class="mat-mdc-focus-indicator"></span>
                        <span matripple="" class="mat-ripple mat-mdc-button-ripple"></span>
                        <span class="mat-mdc-button-touch-target"></span></button>
                      <div _ngcontent-etx-c320="" style="width: 100%;" class="ng-star-inserted">
                        <table class="request-title-width">
                          <tbody>
                            <tr>
                              <td class="request-title-border"><span class="response-title-value">  {{transactionRequestData.MessageID}}</span></td>
                              <td class="request-title-border"><span class="response-title-value">  {{transactionRequestData.RelatesToMessageID}}</span></td>
                              <td class="request-title-border"><span class="response-title-value">  {{transactionRequestData.MessageType}}</span></td>
                              <td class="request-title-border"><span class="response-title-value">  {{transactionRequestData.Species}}</span></td>
                              <td class="request-title-border"><span class="response-title-value">  {{transactionRequestData.RequestDate}}</span></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                      <mat-tree style="margin-left:3%;margin-top:1%;" *ngIf="!IsCollapsed" [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="example-tree">
                          <mat-tree-node  *matTreeNodeDef="let node" matTreeNodeToggle>
                            <div *ngIf="!node.markedForDelete">
                            <li class="mat-tree-node" >
                              <button mat-icon-button disabled></button>
                              <!-- <span style="color: #4E187C;">{{node.filename}}</span>  &nbsp;:&nbsp;  <span style="color: #009688">{{node.type}}</span> -->
                              <span style="color: rgba(0,0,0,0.8);">{{node.filename}}</span>  &nbsp;:&nbsp;  <span style="color: #07a">{{node.type}}</span>
                            </li>
                          </div>
                          </mat-tree-node>
                        
                          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild" >
                            <li *ngIf="!node.markedForDelete">
                              <div class="mat-tree-node">
                                <button mat-icon-button matTreeNodeToggle
                                        [attr.aria-label]="'toggle ' + node.filename">
                                  <mat-icon class="mat-icon-rtl-mirror">
                                    {{nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                  </mat-icon>
                                </button>
                                <span style="color: rgba(0,0,0,0.8);">{{node.filename}}</span>
                              </div>
                              <ul [class.example-tree-invisible]="!nestedTreeControl.isExpanded(node)">
                                <ng-container matTreeNodeOutlet></ng-container>
                              </ul>
                            </li>
                          </mat-nested-tree-node>
                        </mat-tree>
                  </mat-card-content>
            </mat-tab>
            <mat-tab label="Response">
              <mat-card-content style="height: 480px; overflow-y: auto;">
                <div class="store-search-row">
                  <div class="form-group search-group">
                    <mat-form-field class="ffs" appearance="outline" style=" font-size: 18px;">
                      <input
                        id="responseFilternodeId"
                        matInput
                        minlength="2"
                        (keyup)="applyResponseFilter($event)"
                        placeholder="Search"
                        #input
                        autocomplete="off"
                      >
                    </mat-form-field>
                  </div>
                  <div class="export-button" style="gap: 5%; margin-right: 2%;">
                    <button mat-raised-button type="button" class="btn-save" (click)="expandorcollapseResponse('expand')">Expand All</button>
                    <button mat-raised-button style="margin-left: 1%;" type="button" class="btn-cancel" (click)="expandorcollapseResponse('collapse')">Collapse All</button>
                  </div>
                </div>






                <div _ngcontent-etx-c320="" style="margin-left: 48px;" class="ng-star-inserted" *ngIf="IsResponseAvailable">
                  <table class="response-title-width">
                    <tbody>
                      <tr>
                        <td class="response-key-title-border" style="width: 15%;"><span class="response-title-key">  Message Id</span></td>
                        <td class="response-key-title-border" style="width: 15%;"><span class="response-title-key">  Relates To Message Id</span></td>
                        <td class="response-key-title-border" style="width: 14%;"><span class="response-title-key">  Message Type</span></td>
                        <td class="response-key-title-border" style="width: 8%;"><span class="response-title-key">  From</span></td>
                        <td class="response-key-title-border" style="width: 8%;"><span class="response-title-key">  To</span></td>
                        <td class="response-key-title-border" style="width: 20%;"><span class="response-title-key">  Response Status</span></td>
                        <td class="response-key-title-border" style="width: 15%;"><span class="response-title-key">  Response Date</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                



                <mat-tree [dataSource]="responseNestedDataSource" [treeControl]="responseNestedTreeControl" class="example-tree">
                  <mat-tree-node  *matTreeNodeDef="let node" matTreeNodeToggle>

                    <div *ngIf="!node.markedForDelete && node.filename!='ResponseTitle'">
                      <li class="mat-tree-node" >
                        <button mat-icon-button disabled></button>
                        <span style="color: rgba(0,0,0,0.8);">{{node.filename}}</span>  &nbsp;:&nbsp;  <span style="color: #07a">{{node.type}}</span>
                      </li>
                    </div>

                  </mat-tree-node>

                  <div [ngClass]="node.isRootNode ? 'view-inline-block' : ''" *matTreeNodeDef="let node;when: hasResponseNestedChild">
                    <mat-nested-tree-node>
                      <li *ngIf="!node.markedForDelete" [ngClass]="!node.isRootNode ? 'li-margin' : ''">
                        <div class="mat-tree-node">
                          <button mat-icon-button matTreeNodeToggle
                                  [attr.aria-label]="'toggle ' + node.filename" style="padding-top: 18px"  [disabled]="!node.isJsonAvail">
                            <mat-icon class="mat-icon-rtl-mirror" [hidden]="!node.isJsonAvail">
                              {{responseNestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                          </button>
                          <div *ngIf="!node.isRootNode" style="color: rgba(0,0,0,0.8);">{{node.filename}}</div>
                          <div style="width: 100%;" *ngIf="node.isRootNode" [innerHTML]="buildResponseTitle(node.filename)"></div>
                        </div>
                        <ul [class.example-tree-invisible]="!responseNestedTreeControl.isExpanded(node)">
                          <ng-container matTreeNodeOutlet></ng-container>
                        </ul>
                      </li>
                    </mat-nested-tree-node>
                  </div>
                </mat-tree>







              </mat-card-content>
            </mat-tab>
          </mat-tab-group>
    </mat-card-content>
</mat-card>

